import {pdf} from '@react-pdf/renderer';
import React from 'react';

export async function generatePdfFile(document: React.ReactElement) {
  const blob = await pdf(document).toBlob();

  return new File([blob], 'farm-credit-report.pdf', {
    type: 'application/pdf',
  });
}
